'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const designSystem = require('@zapier/design-system');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_7zs2k_1";
const styles = {
	root: root
};

function isLinkProps(props) {
  return typeof props.href === "string";
}
const ActionChip = (props) => {
  const { href, hrefLang, isDisabled, onPress, size, target } = props;
  if (isLinkProps(props)) {
    return React__default.default.createElement(reactAriaComponents.Link, { className: styles.root, "data-size": size, "data-zds": true, href, hrefLang, isDisabled, onPress, target }, (linkRenderProps) => typeof props.children === "function" ? props.children(linkRenderProps) : props.children);
  }
  return React__default.default.createElement(reactAriaComponents.Button, { className: styles.root, "data-size": size, "data-zds": true, isDisabled, onPress }, (buttonRenderProps) => typeof props.children === "function" ? props.children(buttonRenderProps) : props.children);
};
const ActionChipIcon = ({ name }) => React__default.default.createElement(designSystem.Icon, { name });

exports.ActionChip = ActionChip;
exports.ActionChipIcon = ActionChipIcon;
//# sourceMappingURL=ActionChip.cjs.js.map
